var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeDisabled = function SvgEyeDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 2.3c-.4-.4-1-.5-1.4-.1-.4.4-.5 1-.1 1.4l12 14c.4.4 1 .5 1.4.1.4-.4.5-1 .1-1.4l-12-14zM5.5 9.5c0 1.1.4 2.1 1 2.9-1.4-.6-2.6-1.5-3.5-2.5-.2-.2-.2-.6 0-.8.5-.6 1-1.1 1.7-1.5L3.4 6.1c-.7.5-1.2 1-1.8 1.6-.8 1-.8 2.5 0 3.4 2 2.3 5 3.8 8.4 3.8h1L5.6 8.7c-.1.2-.1.5-.1.8zM18.4 7.8c-2-2.3-5-3.8-8.4-3.8-.6 0-1.2 0-1.7.1l6 6.9c.2-.5.3-1 .3-1.6 0-1.1-.4-2.1-1-2.9C15 7 16.2 7.9 17.1 9c.2.2.2.5 0 .8-.6.7-1.4 1.3-2.2 1.8l1.3 1.5c.9-.6 1.6-1.2 2.3-2 .7-.9.7-2.3-.1-3.3z"
  })));
};
export default SvgEyeDisabled;